import React from "react";
import { Grid, Typography, Avatar, Rating, Box } from "@mui/material";
import Div from "@jumbo/shared/Div";
import EnrollButton from "components/EnrollButton";
import {
  PROGRAMMING_LANGUAGES,
  COURSE_FOR,
  DURATION,
} from "app/utils/constants/constants";

const CourseOverview = ({ plan, isLoggedIn, authUser, navigate, location }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", lg: "row" },
        gap: 2,
        mb: 3,
      }}
    >
      <Grid item xs={12} md={3}>
        <Avatar
          sx={{
            width: { xs: "100%", lg: 400 },
            height: { xs: "100%", lg: 250 },
            "& img": { objectFit: "contain" },
          }}
          alt={plan.name}
          src={`data:${plan.thumbnailContentType};base64,${plan.thumbnail}`}
          variant="rounded"
        />
      </Grid>

      <Grid container alignItems="center">
        <Grid item xs={12} sx={{ paddingLeft: 2 }}>
          <Div>
            <Typography variant="h3" sx={{ fontWeight: 600, mb: 2 }}>
              {plan.name}
            </Typography>
          </Div>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {plan.description}
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={6} sm={4}>
              <Typography variant="body2">
                <strong>Language:</strong>{" "}
                {PROGRAMMING_LANGUAGES[plan.programmingLanguage] ||
                  plan.programmingLanguage}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="body2">
                <strong>Level:</strong>{" "}
                {COURSE_FOR[plan.courseFor] || plan.courseFor}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="body2">
                <strong>Duration:</strong> {plan.duration}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="body2">
                <strong>Lectures:</strong> {plan.numberOfLectures}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="body2">
                <strong>Price:</strong> ₹{plan.price.toFixed(0) / 100}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="body2">
                <strong>Validity:</strong> {plan.validity}{" "}
                {DURATION[plan.validityUnit] || plan.validityUnit}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="body2">
                <strong>Enrolled:</strong> {plan.peopleEnrolled} learners
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  Rating:
                </Typography>
                {plan.rating ? (
                  <>
                    <Rating
                      name="course-rating"
                      value={plan.rating}
                      precision={0.5}
                      readOnly
                    />
                  </>
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Not Rated
                  </Typography>
                )}
              </Box>
            </Grid>
            <Grid item xs={6} sm={4}>
              <EnrollButton
                plan={plan}
                isLoggedIn={isLoggedIn}
                authUser={authUser}
                navigate={navigate}
                location={location}
                width="auto"
                size="medium"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CourseOverview;
